'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var BigNumber = require('bignumber.js');

/**
 * Convert the fetched gas price (10x gwei) to regular gwei,
 * rounded to the nearest .5.
 *
 * @param {BigNumber} fetchedPrice
 */
var convertGasPriceToGwei = function convertGasPriceToGwei(fetchedPrice) {
  return parseFloat(fetchedPrice.div(5).integerValue().times(0.5).toFixed(1));
};

/**
 * Fetches the current recommended gas prices.
 *
 * @returns {Ojbect} the gas prices - gwei.
 */
var fetchRecommendedGasPrices = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', fetch(_constants.ETH_GAS_PRICE_ENDPOINT).then(function (response) {
              if (response.status === 200) {
                return response.json();
              }
              var error = new Error('Received ' + response.status + ' while attempting to fetch gas');
              error.body = response.json();
              throw error;
            }).then(function (data) {
              var safeLow = BigNumber(data.safeLow);
              var average = BigNumber(data.average);
              var fast = BigNumber(data.fast);
              return {
                safeMin: convertGasPriceToGwei(safeLow),
                standard: convertGasPriceToGwei(average),
                fast: convertGasPriceToGwei(fast)
              };
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function fetchRecommendedGasPrices() {
    return _ref.apply(this, arguments);
  };
}();

exports.default = fetchRecommendedGasPrices;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/fetchGasPrices.js
// module id = 1281
// module chunks = 0